import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { Avatar, Col, Dropdown, Layout, Menu, Row } from 'antd';
import { MenuProps } from 'rc-menu';
import { FC } from 'react';
import React from 'react'
import { useAppDispatch } from '../../redux/hooks';
import { logout } from '../../redux/features/authSlice';


const { Header: AntHeader } = Layout;

const LOGOUT_KEY = 'logout';

const UserMenu: FC = () => {
    const dispatch = useAppDispatch();

    const handleLogout = () => {
        dispatch(logout());
    }

    const handleMenuClick: MenuProps['onClick'] = (info) => {
        if(info.key === LOGOUT_KEY) {
            handleLogout();
        }
    }

    return (
        <Menu
            onClick={handleMenuClick}
            items={[
                {
                    label: 'Log Out',
                    key: LOGOUT_KEY,
                    icon: <LogoutOutlined />
                },
            ]}
        />
    )
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Header: FC<any> = ({ className, style }: any) => {
    return (
        <AntHeader className={className} style={style}>
            <Row>
                <Col span={4} order={1}></Col>
                <Col span={16} order={2}></Col>
                <Col span={4} order={3} style={{ textAlign: 'end' }}>
                    <Dropdown overlay={<UserMenu />} trigger={['click']}>
                        <Avatar size="large" icon={<UserOutlined />} style={{ marginRight: '25px' }} />
                    </Dropdown>
                </Col>
            </Row>
        </AntHeader>
    );
};

export default Header;
